import { render, staticRenderFns } from "./sponsors.vue?vue&type=template&id=279a32ee"
import script from "./sponsors.vue?vue&type=script&lang=ts"
export * from "./sponsors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports